import React, { useState } from "react"
import { Button, Checkbox, Form, Input, message } from "antd"
import AuthService from "src/services/AuthService"
import { getStorage, setStorage, setStorageCookie } from "src/lib/storage"
import STORAGE from "src/lib/storage"
import { useLocation, useNavigate } from "react-router-dom"
import ROUTER from "src/router"
import { BlockInput, ButtonStyle } from "src/pages/ANONYMOUS/LoginPage/styled"
import SvgIcon from "src/components/SvgIcon"
import IconBase from "src/components/IconBase"
const RegisterForm = ({ setActiveTab }) => {
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm()
  const navigate = useNavigate()

  const onRegister = async () => {
    setLoading(true)
    form
      .validateFields()
      .then(async values => {
        try {
          const payload = {
            ...values,
            type: "STAFF", // Mặc định gán role là USER
            target_url: window.location.origin,
          }
          const response = await AuthService.register(payload)
          setActiveTab("login")
          message.success(
            response?.message || "Đăng ký thành công vui lòng xác thực email",
          )
          form.resetFields()
          setLoading(false)
        } catch (err) {
          const {
            response: { data },
          } = err
          setLoading(false)

          // Nếu có lỗi chi tiết từ server theo dạng `errors`
          if (data?.errors) {
            const fieldErrors = Object.entries(data.errors).map(
              ([field, message]) => ({
                name: field,
                errors: [message],
              }),
            )
            form.setFields(fieldErrors)
          } else {
            // Trường hợp chỉ có message tổng quát
            form.setFields([
              {
                name: "email", // có thể gán vào một field bất kỳ hoặc tạo toast báo lỗi chung
                errors: [data?.message || "Đăng ký thất bại"],
              },
            ])
          }
        }
      })
      .catch(() => {
        setLoading(false)
      })
  }
  return (
    <Form form={form} size={"large"} layout="vertical">
      <Form.Item
        label="Họ và tên"
        name="fullname"
        rules={[{ required: true, message: "Vui lòng nhập họ và tên" }]}
      >
        <BlockInput>
          <SvgIcon name={"user_login"} />
          <Input placeholder="Nhập họ và tên" />
        </BlockInput>
      </Form.Item>
      <Form.Item
        label="Số điện thoại"
        name="phone"
        rules={[
          { required: true, message: "Vui lòng nhập số điện thoại" },
          // {
          //   pattern: /^0\d{9}$/,
          //   message: "Số điện thoại không hợp lệ",
          // },
        ]}
      >
        <BlockInput>
          <IconBase name="phone" />
          <Input placeholder="Nhập số điện thoại" />
        </BlockInput>
      </Form.Item>
      <Form.Item
        label="Email"
        name="email"
        rules={[
          { required: true, message: "Vui lòng nhập email" },
          { type: "email", message: "Email không hợp lệ" },
        ]}
      >
        <BlockInput>
          <IconBase name="email" />
          <Input placeholder="Nhập email" />
        </BlockInput>
      </Form.Item>
      <Form.Item
        label="Mật khẩu"
        name="password"
        rules={[
          { required: true, message: "Vui lòng nhập mật khẩu" },
          { min: 6, message: "Mật khẩu ít nhất 6 ký tự" },
        ]}
      >
        <BlockInput>
          <SvgIcon name={"lock_login"} />
          <Input.Password
            placeholder="Nhập mật khẩu"
            autocomplete="new-password"
          />
        </BlockInput>
      </Form.Item>
      <Form.Item
        label="Xác nhận mật khẩu"
        name="passwordConfirm"
        dependencies={["password"]}
        rules={[
          { required: true, message: "Vui lòng xác nhận mật khẩu" },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue("password") === value) {
                return Promise.resolve()
              }
              return Promise.reject("Mật khẩu không khớp")
            },
          }),
        ]}
      >
        <BlockInput>
          <SvgIcon name={"lock_login"} />
          <Input.Password placeholder="Nhập lại mật khẩu" />
        </BlockInput>
      </Form.Item>

      <ButtonStyle
        loading={loading}
        btnType="primary"
        type="submit"
        htmlType="submit"
        onClick={onRegister}
      >
        Đăng ký
      </ButtonStyle>
    </Form>
  )
}

export default RegisterForm
